<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <template v-if="isEndNode(node)">
      <div
        v-if="nodeShouldBeDisplay(node)"
        :style="lineStyle"
        class="mt-1"
        style="display: grid;grid-template-columns: repeat(48, 1fr);"
      >
        <div
          v-for="(grid,index) in nodeToLine"
          :key="index"
          :style="gridStyle"
          style="min-height: 21px;"
        >
          {{ grid }}
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(n,index) in parseChildNodes(node)"
        :key="index"
      >
        <i-k-p-r-node
          :level="level+'&nbsp;&nbsp;&nbsp;&nbsp;'"
          :node="n"
        />
      </div>
    </template>
  </div>
</template>

<script>
  import { parse } from 'node-html-parser'

  export default {
    name: 'IKPRNode',
    props: {
      node: {},
      level: {},
      lineLength: { default: 48 },
    },
    data: function () {
      return {}
    },
    computed: {
      tagNameStack () {
        const stack = []
        stack.push(this.node.tagName)
        if (this.node.inheritTagName) {
          stack.push(...this.node.inheritTagName)
        }

        return stack
      },

      gridStyle () {
        let fontSizeX = 1
        let fontSizeY = 1
        let fontWeight = 400
        let fontSize = '14px'
        let backgroundColor = ''
        let color = ''
        let style = {}

        if (this.haveTag('CB') || this.haveTag('B')) {
          fontSizeX = 2
          fontSizeY = 2
          fontSize = '28px'
        }
        if (this.haveTag('L')) {
          fontSizeY = 2
        }
        if (this.haveTag('RC')) {
          backgroundColor = 'black'
          color = 'white'
        }
        if (this.haveTag('W')) {
          fontSizeX = 2
        }
        if (this.haveTag('BOLD')) {
          fontWeight = 900
        }
        style = {
          gridColumnStart: 'span ' + fontSizeX,
          gridRowStart: 'span ' + fontSizeY,
          fontWeight: fontWeight,
          fontSize: fontSize,
          background: backgroundColor,
          color: color,
        }
        return style
      },
      lineStyle () {
        const style = {}
        if (this.haveTag('CB') || this.haveTag('C')) {
          style.display = 'flex'
          style.justifyContent = 'center'
        }
        return style
      },
      nodeToLine () {
        let fontSizeX = 1
        let defaultChar = ' '
        let content = this.node.innerHTML
        if (this.node.nodeType === 3) { // text node
          content = this.node.rawText.trim()
        }
        let line = []
        let left = content
        let right = ''
        switch (this.node.tagName) {
          case 'LR':
            [left, right] = content.split('|*|')
            break
          case 'LINE':
            defaultChar = content
            break
          case 'QR':
            left = '/QRCODE/' + content + '/QRCODE/'
            break
          default:
        }
        if (this.haveTag('CB') || this.haveTag('B') || this.haveTag('W')) {
          fontSizeX = 2
        }
        line = Array(this.lineLength / fontSizeX).fill(defaultChar)
        this.fillLine(line, left)
        this.fillLine(line, right, 'right')
        if (this.haveTag('CB') || this.haveTag('C')) {
          line = left
        }
        return line
      },
    },
    methods: {
      haveTag (tagName) {
        return this.tagNameStack.includes(tagName)
      },
      parseChildNodes (node) {
        return node.childNodes.map(n => {
          n.inheritTagName = []

          if (node.inheritTagName) {
            n.inheritTagName.push(...node.inheritTagName)
          }
          if (node.tagName) {
            n.inheritTagName.push(node.tagName)
          }

          if (typeof n.tagName === 'undefined') {
            if (typeof node.tagName !== 'undefined' && node.tagName) {
              n.tagName = node.tagName
            }
          }
          return n
        })
      },
      nodeShouldBeDisplay (node) {
        return node.nodeType === 3 || node.innerHTML
      },
      fillLine (line, string, orientation = 'left') {
        if (orientation === 'left') {
          for (const i in string) {
            line[i] = string[i]
          }
        } else {
          for (const i in string) {
            line[line.length - 1 - i] = string[string.length - 1 - i]
          }
        }
      },
      isEndNode (node) {
        return node.childNodes.length === 0 ||
          node.childNodes.every(n => n.nodeType === 3 ||
            n.rawTagName === 'RC')
      },
      parseNode (tpl) {
        return parse(tpl)
      },
    },
  }
</script>

<style scoped>

</style>
